import React from "react";

import { FilterProps } from "./types";
import Tag from "./Tag";
import { useAppContext } from "../../context/AppContext";

import styles from "./productFilters.module.css";
const FilterSection = ({
  title,
  filters,
  activeFilters,
  onClick,
}: FilterProps) => {
  const { hiddenFilters } = useAppContext();

  return (
    <div className={styles.filterSection}>
      <div className={styles.title}>{title}</div>
      {filters.map((tag, index) => {
        if (!hiddenFilters.includes(tag.name.toLowerCase())) {
          return (
            <Tag
              isFilter={true}
              key={index}
              filter={tag}
              selected={activeFilters.indexOf(tag.value) > -1}
              onClick={onClick}
            />
          );
        }
      })}
    </div>
  );
};

export default FilterSection;
